import * as types from './types'

export const mutations = {
	[types.LOADER_IN] (state) {
		state.loader = true
	},
	[types.LOADER_OUT] (state) {
		state.loader = false
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Loader/mutations.js